import api from "@/api";
console.log("这里是comment-----", api.managerHost);
// 请求Java后台环境  上传头像
export const uploadURL = api.managerHost + "/api/users/portrait";
// 强制退款凭证上传
export const uploadfiles = api.managerHost + "/api/upload/file";
export const uploadHeaders = { token: localStorage.getItem("kposToken") || "" };
export function wrapUploadRes(res) {
  if (!res) return res;
  const url =
    (res.BODY && res.BODY.url) ||
    (res.data && res.data.url) ||
    (res.data && res.data.BODY && res.data.BODY.url) ||
    res.url;
  if (url) {
    if (!res.BODY) res.BODY = {};
    if (!res.BODY.url) res.BODY.url = url;
    if (!res.HEAD) res.HEAD = { CODE: res.code || "000", MSG: res.msg || "" };
  }
  return res;
}
// 审核状态 auditStatus
export const AUDITSTATUS = {
  "1": "机构审核中",
  "2": "机构审核不通过",
  "3": "平台审核中",
  "4": "平台审核不通过",
  "5": "平台审核通过"
};

// 代付订单状态 Payment order status
export const PAYMENTORDERSTATUS = {
  "1": "申请中",
  "2": "系统处理中",
  "3": "系统处理失败",
  "4": "代付通道处理中",
  "5": "代付成功",
  "6": "代付失败"
};

// 账户类型  Account type
export const ACCOUNTTPYE = {
  "1": "对私",
  "0": "对公"
};

15652763082;
// 内容类型（全部，文本，图片，文件，表情，语音，视频） Content type
export const CONTENTYPE = {
  "1": "文本",
  "3": "图片",
  "4": "位置",
  "5": "文件",
  "7": "动态表情",
  "2": "语音",
  "6": "视频",
  "10": "名片"
};

// 举报类型 Report type
export const REPORTYPE = {
  "1": "举报用户",
  "2": "举报动态",
  "3": "举报群",
  "4": "红包投诉",
  "5": "转账投诉"
};

// 订单状态
export const ORDERSTATE = {
  1: "付款中",
  2: "付款成功",
  3: "付款失败",
  4: "订单失效"
};

// 订单类型
export const ORDERTYPE = {
  1: "充值",
  2: "开通VIP",
  3: "购买靓号",
  4: "提现"
};

// 实名状态 Real name status   1:未认证;2:审核中;3:成功;10:失败
export const REALNAMESTATUS = {
  1: "未认证",
  2: "审核中",
  3: "成功",
  10: "失败"
};

// 业务类型
export const BUSINESSTYPE = {
  1: "充值",
  2: "购买会员",
  3: "购买靓号",
  4: "转账",
  5: "红包",
  6: "提现",
  7: "提现退款",
  8: "转账退还",
  9: "红包失效退回",
  10: "转账失效退回"
};

// 支付方式
export const PAYTYPE = {
  1: "微信",
  2: "支付宝",
  3: "仟信钱包",
  4: "苹果"
};

// 提现状态  1：申请中；2：处理中 3：清算中；4：成功；10：失败；11:驳回
export const WITHDRAWSTATUS = {
  1: "申请中",
  2: "处理中",
  3: "清算中",
  4: "成功",
  10: "失败",
  11: "驳回"
};

// 银行卡状态 1:未绑定;2:未认证;3:已绑定;4:已认证
export const BANKSTATE = {
  1: "未绑定",
  2: "未认证",
  3: "已绑定",
  4: "已认证"
};

// 处理方式
export const HANDLINGMETHOD = {
  1: "情况属实-永久冻结",
  2: "情况属实-临时冻结",
  3: "情况属实-警告",
  4: "情况不属实，忽略",
  5: "情况属实-永久禁言",
  6: "情况属实-临时禁言",
  7: "情况属实-钱包冻结"
};

export const quanxianlist = {
  RECHARGE: "充值",
  TRANSFER: "转账",
  WITHDRAW: "提现"
};

export default {
  uploadURL,
  AUDITSTATUS,
  PAYMENTORDERSTATUS,
  ACCOUNTTPYE,
  CONTENTYPE,
  REPORTYPE,
  ORDERSTATE,
  ORDERTYPE,
  REALNAMESTATUS,
  BUSINESSTYPE,
  PAYTYPE,
  WITHDRAWSTATUS,
  BANKSTATE,
  HANDLINGMETHOD,
  uploadfiles,
  uploadHeaders,
  wrapUploadRes,
  quanxianlist
};



// WEBPACK FOOTER //
// ./src/oos/utils/CommonData.js